import { Field, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type C49ClickablePhotoContentWrapperProps = RenderingProps<
  C49ClickablePhotoContentWrapperFields,
  C49ClickablePhotoContentWrapperParams,
  PhotoContentCardCarouselPlaceholder
>;

export type C49ClickablePhotoContentWrapperParams = {
  HeadlineTag?: string;
  ContentAlignment?: string;
  CTAStyle?: string;
  BackgroundColor?: string;
} & AnchorTargetParams &
  TranslationOptionsParams;

export interface C49ClickablePhotoContentWrapperFields {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  SupportCopyBottom?: RichTextField;
  CTA?: LinkField;
}

export interface PhotoContentCardCarouselPlaceholder {
  'clickable-photo-content-card-container-{*}'?: {
    componentName?: string;
  }[];
}
